/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBack = createReactComponent("outline", "arrow-back", "IconArrowBack", [["path", { "d": "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1", "key": "svg-0" }]]);

export { IconArrowBack as default };
//# sourceMappingURL=IconArrowBack.mjs.map
